import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100px;
  margin-top: 0.75rem;
  padding: .3rem;
  flex-direction: column;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  .full--{
    display: flex;
    justify-content: end;
    width: 100%;
    > span {
      display: flex;
      position: absolute;
      right: 5px;
      top: 5px;
      justify-content: center;
      align-items: center;
      padding: .2rem;
      color: #1D86FF;
      border-radius: 4px;
      cursor: pointer;
      &:hover{
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
      }
    }
  }
  .--chart{
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    padding: 0.33rem;
    canvas{
      max-height: 400px;
    }
  }
`;